const userIsLegal = (user) => {
    return !!user.organization;
};

export {
    userIsLegal
};